import type { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { type PropType, defineComponent, h, shallowRef } from 'vue';
import { FormData, LoginForm } from '../../components/login-form';
import { Page } from '../../components/page';
import { RegisterPage } from '../register-page';
import { Route } from '@phi/vue-router';
import { open_onshape_oauth_page } from '../../onshape';
import { ForgotPasswordPage } from '../forgot-password-page';

export const LoginPage = defineComponent({
    name: 'LoginPage',

    props: {
        app: {
            required: true,
            type: Object as PropType<IFrontendServiceContainer>,
        },

        route: {
            required: true,
            type: Function as PropType<Route>,
        },
    },

    setup({ app, route }) {
        const auth = app.authentication;
        const util = app.util;
        const pop_under = app.pop_under_with_router;
        const state = app.state;

        // state
        let sending = false;
        const error = shallowRef(undefined as undefined | Error);

        // methods
        function on_login(form: FormData) {
            if (sending) return;
            sending = true;
            error.value = undefined;
            auth.phi_log_in(form.email, form.password)
                .then(x => {
                    if (x instanceof Error)
                        return error.value = x;
                    else
                        auth.authenticate_through_phi(x);
                })
                .finally(() => sending = false);
        }

        function on_onshape() {
            pop_under.hide_pop_under();
            state.spinner = 'Please wait...';
            open_onshape_oauth_page();
        }

        function on_forgot() {
            route(() => h(ForgotPasswordPage, { app, route }));
        }

        // render
        return () => h(Page, { light: app.util.dark_mode_enabled() }, () => h(LoginForm, {
            error: error.value,
            light: util.dark_mode_enabled(),
            onLocal: auth.authenticate_locally,
            onRegister: () => route((route) => h(RegisterPage, { app, route })),
            onOnshape: on_onshape,
            onLogin: on_login,
            onForgot: on_forgot,
        }));
    },
});
